import React from 'react';
import { Link } from 'react-router-dom';

function QuestionSummary(props) {
  const { question, onDelete } = props;

  return (
    <div className="col s12 m6">
      <div className="card card-question z-depth-0 project-summary">
        <div className="card-content grey-text text-darken-3">
          <div className="question-type">
            <small>T{question.type}</small>
          </div>
          <h6 className="question-id">ID: {question.id}</h6>
          <span className="card-title question-title">{question.question}</span>
          {question.questionOptions &&
            question.questionOptions.map((answer) => {
              return (
                <li className={answer.isAnswer ? 'optionTrue' : 'optionFalse'} key={answer.option}>
                  {answer.option}
                </li>
              );
            })}
        </div>
        <div className="card-action">
          {/*
          <Link to={'/questions/' + question.id} key={question.id}>
            View
          </Link>
          */}
          <Link to={'/editQuestion/' + question.id} key={'edit_' + question.id}>
            Edit
          </Link>
          <Link to="#" onClick={(e) => onDelete(question.id, question)} key={'delete_' + question.id}>
            Delete
          </Link>
        </div>
      </div>
    </div>
  );
}

export default QuestionSummary;
